function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "transactions_svg__a",
  opacity: 1,
  d: "M2 0h14v1H2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "transactions_svg__b",
  opacity: 1,
  d: "M2 9h14v1H2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "transactions_svg__c",
  opacity: 1,
  d: "M2 3h12.444v1H2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "transactions_svg__d",
  opacity: 1,
  d: "M2 6h12.444v1H2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "transactions_svg__e",
  opacity: 1,
  d: "M2 12h12.444v1H2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "transactions_svg__f",
  opacity: 1,
  d: "M2 15h12.444v1H2z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#transactions_svg__a",
  fill: "#8395B7"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#transactions_svg__b",
  fill: "#8395B7"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#transactions_svg__c",
  fill: "#8395B7"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#transactions_svg__d",
  fill: "#8395B7"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#transactions_svg__e",
  fill: "#8395B7"
});

var _ref8 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#transactions_svg__f",
  fill: "#8395B7"
});

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.5a0e2c1d.svg";
export { ForwardRef as ReactComponent };